<template>
  <v-container
    fluid
    grid-list-md
    fill-height
  >
    <v-layout
      row
      wrap
    >
      <v-flex>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <router-view v-else-if="partner"></router-view>
        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="info"
          v-else
        >
          נתוני ספק לא נמצאו. נסו לטעון את הדף מחדש
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GeneralDetails from "./partner/GeneralDetails";
import { format } from "date-fns";

export default {
  data() {
    return {
      tab: null,
      fetching: true
    };
  },
  computed: {
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.$store.getters["entity"]("partners", this.partnerId);
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    format,
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/partners/" + this.partnerId,
          entityType: "partners",
          schema: "partnerListSchema"
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {
    GeneralDetails
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partners/Partner.vue